import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { IsavCommonModule } from '../../common/common.module';
import { CanEditPerson } from './auth/can-edit-person';
import { PersonEditGuard } from './auth/person-edit.guard';
import { PeopleRegisterPage } from './people-register-page/people-register-page';
import { PeopleRegisterForm } from './people-register-form/people-register-form';
import { NotAuthenticatedGuard } from '../../core/auth/not-authenticated.guard';
import { PeopleSearchPage } from './people-search-page/people-search-page';
import { PeopleLandingPage } from './people-landing-page/people-landing-page';
import { SearchModule } from '../../core/search/search.module';
import { PeopleResourceService } from '../../core/api/people-resource.service';
import { PeopleViewPage } from './people-view-page/people-view-page';
import { IriWithSearchFallbackGuard } from '../../core/auth/iri-with-search-fallback.guard';
import { IriResolver } from '../../core/api/iri.resolver';
import { AuthenticatedGuard } from '../../core/auth/authenticated.guard';
import { PeopleEditPage } from './people-edit-page/people-edit-page';
import { PeopleEditForm } from './people-edit-form/people-edit-form';
import { PeopleSharedModule } from '../people-shared/people-shared.module';
import { PeopleEditCredentials } from './people-edit-credentials/people-edit-credentials';
import { PeopleEditAdminForm } from './people-edit-admin-form/people-edit-admin-form';
import { PeopleAssociatedContent } from './people-associated-content/people-associated-content';
import { UtilitiesModule } from '../../shared/utilities/utilities.module';
import { CanDeactivateChangesWarning } from '../../core/changes-warning/can-deactivate-changes-warning.service';
import { ChangesWarningSharedModule } from '../../core/changes-warning/changes-warning-shared.module';

const ROUTES: Routes = [
    { path: '', pathMatch: 'full', component: PeopleLandingPage },
    { path: 'search', pathMatch: 'full', component: PeopleSearchPage },
    {
        path: 'view',
        pathMatch: 'prefix',
        component: PeopleViewPage,
        canActivate: [IriWithSearchFallbackGuard],
        resolve: { person: IriResolver },
        runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
        children: [{ path: ':slug', component: PeopleViewPage }],
    },
    {
        path: 'edit',
        pathMatch: 'prefix',
        component: PeopleEditPage,
        canActivate: [IriWithSearchFallbackGuard, AuthenticatedGuard, PersonEditGuard],
        canDeactivate: [CanDeactivateChangesWarning],
        resolve: { person: IriResolver },
        runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
        children: [{ path: ':slug', component: PeopleEditPage }],
    },
    {
        path: 'register',
        component: PeopleRegisterPage,
        canActivate: [NotAuthenticatedGuard],
    },
];

@NgModule({
    declarations: [
        PeopleRegisterPage,
        PeopleRegisterForm,
        PeopleSearchPage,
        PeopleLandingPage,
        PeopleViewPage,
        PeopleEditPage,
        PeopleEditForm,
        PeopleEditAdminForm,
        PeopleEditCredentials,
        PeopleAssociatedContent,
        CanEditPerson,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(ROUTES),
        SharedModule,
        IsavCommonModule,
        ReactiveFormsModule,
        PeopleSharedModule,
        UtilitiesModule,
        SearchModule.forFeature('people', PeopleResourceService),
        ChangesWarningSharedModule,
    ],
    providers: [PersonEditGuard],
})
export class PeopleModule {}
